import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

/**
 * a wrapper to detail form representink a page wih url
 * @param {any} props contains: backUrl, title, showPopup
 * @exports DetailView
 */
export default function DetailView(props) {
    const { backUrl, title, showPopup } = props;
    const detailRef = useRef(null);

    return showPopup ?
        <div id='windowContent' className='window_cont' ref={detailRef}>
            {props.children}
        </div>
         :
        <view ref={detailRef} >
            <toolbar>
                <div effect='material' className='button white mini back'>
                    <Link to={backUrl}><icon>left</icon></Link>
                </div>
                <separator vertical=""></separator>
                <div>
                    <strong><text>{title || ""}</text></strong>
                </div>
            </toolbar>
            {props.children}
        </view>
        ;
}